module.exports = __webpack_public_path__ + "static/media/bell-hand2.3de88d46.aac";